import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/20 text-primary hover:bg-primary/30',
        secondary: 'border-silver/40 bg-surface-raised text-silver-dark hover:bg-silver/40',
        draft: 'border-dashed border-silver-dark/50 bg-transparent text-silver-dark hover:bg-silver/30',
        success: 'border-accent-success/40 bg-accent-success/10 text-accent-success hover:border-accent-success/60',
        destructive: 'border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/80',
        warning: 'border-accent-warning/40 bg-accent-warning/10 text-accent-warning hover:bg-accent-warning/20',
        pending: 'border-yellow-600/30 bg-accent-warning/10 text-yellow-600 hover:border-yellow-600/50',
        outline: 'text-foreground'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
